import { QueryConfig } from "store/utils/query-config";

export const bookingsDefaultQueryConfig: QueryConfig = {
  query: {},
  options: {
    sortBy: ["createdAt"]
  }
};
